import {
  Toast as TamaguiToast,
  ToastProvider as TamaguiToastProvider,
  ToastViewport,
  useToastState,
} from "@tamagui/toast";
import type React from "react";
import type { PropsWithChildren } from "react";
import { YStack } from "tamagui";

export const Toast: React.FC = () => {
  const currentToast = useToastState();

  if (!currentToast || currentToast.isHandledNatively) return null;
  return (
    <TamaguiToast
      key={currentToast.id}
      duration={currentToast.duration}
      enterStyle={{ opacity: 0, scale: 0.5, y: -25 }}
      exitStyle={{ opacity: 0, scale: 1, y: -20 }}
      y={0}
      opacity={1}
      scale={1}
      animation="100ms"
      viewportName={currentToast.viewportName}
      backgroundColor={"$backgroundBlock"}
      borderRadius={10}
      paddingHorizontal="$space.larger"
      paddingVertical="$space.medium"
      shadowColor={"#000000"}
      shadowOpacity={0.15}
      shadowRadius={24}
    >
      <YStack gap="$medium">
        <TamaguiToast.Title>{currentToast.title}</TamaguiToast.Title>
        {!!currentToast.message && (
          <TamaguiToast.Description>
            {currentToast.message}
          </TamaguiToast.Description>
        )}
      </YStack>
    </TamaguiToast>
  );
};

export const ToastProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <TamaguiToastProvider>
      <Toast />
      <ToastViewport
        zIndex={"$huge"}
        top={"$space.medium"}
        left={0}
        right={0}
        portalToRoot={true}
      />
      {children}
    </TamaguiToastProvider>
  );
};
